<template>
  <div>
    <PicList
      :category="category"
      :subtabs="subtabs"
      @showpic="$emit('showPic', $event)"
    ></PicList>
  </div>
</template>

<script>
import PicList from './PicList';

export default {
  components: {
    PicList
  },
  data() {
    return {
      subtabs: [
        {
          name: "桌面",
          category: "平面设计-桌面"
        },
        {
          name: "屏保",
          category: "平面设计-屏保"
        },
        {
          name: "字母",
          category: "平面设计-字母"
        }
      ],
      category: "平面设计-桌面"
    }
  }
}
</script>

